export default __webpack_public_path__ + "static/media/Group9265.d09f91d0.svg";